import React, { FC } from "react";
import { Controller } from "react-hook-form";
import DrugInfo from "../drugInfo";
import { CurrentAndPriorTreatmentProps } from "../addCase/currentAndPriorTreatment/types";

const AfrezzaPrescription: FC<CurrentAndPriorTreatmentProps> = ({
    control,
    watch,
    setValue,
    getValues,
    resetField,isCloneCase
}): JSX.Element => {

    return (
        <>
            <div className="row">
                <DrugInfo
                    control={control}
                    watch={watch}
                    setValue={setValue}
                    getValues={getValues}
                    resetField={resetField}
                    isCloneCase={isCloneCase}
                />
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="row mb-2">
                        <div className="form-label col-lg-4 col-md-4 col-12">Inhale *</div>
                        <div className="col-lg-8 col-md-8 col-12">
                            <Controller
                                name="prescription_information_attributes.inhale_units"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <div className="input-group input-group-custom">
                                            <input
                                                {...field}
                                                type="text"
                                                //   onChange={(e) => field.onChange(e.target.value.replace(/[^0-9.]/g, ''))}
                                                onChange={(e) => field.onChange(e.target.value)}
                                                className="form-control"
                                                style={{ borderColor: error ? '#dc3545' : '' }}
                                            />
                                            <span className="input-group-text">units per meal</span>
                                        </div>
                                        {error && <div className="text-danger text-small mt-2">{error.message}</div>}
                                    </>
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="row mb-2">
                        <div className="form-label col-lg-4 col-md-4 col-12">Use additional *</div>
                        <div className="col-lg-8 col-md-8 col-12">
                            <Controller
                                name="prescription_information_attributes.additional_units"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <div className="input-group input-group-custom">
                                            <input
                                                {...field}
                                                type="text"
                                                onChange={(e) => field.onChange(e.target.value)}

                                                // onChange={(e) => field.onChange(e.target.value.replace(/[^0-9.]/g, ''))}
                                                className="form-control"
                                                style={{ borderColor: error ? '#dc3545' : '' }}
                                            />
                                            <span className="input-group-text">units as needed</span>
                                        </div>
                                        {error && <div className="text-danger text-small mt-2">{error.message}</div>}
                                    </>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-lg-6">
                    <div className="row mb-2">
                        <div className="form-label col-lg-4 col-md-4 col-12">Max Daily Dose *</div>
                        <div className="col-lg-8 col-md-8 col-12">
                            <Controller
                                name="prescription_information_attributes.total_daily_units"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <div className="input-group input-group-custom small-input">
                                            <input
                                                {...field}
                                                type="text"
                                                onChange={(e) => field.onChange(e.target.value.replace(/[^0-9.]/g, ''))}
                                                className="form-control"
                                                style={{ borderColor: error ? '#dc3545' : '' }}
                                            />
                                            <span className="input-group-text">units</span>
                                        </div>
                                        {error && <div className="text-danger text-small mt-2">{error.message}</div>}
                                    </>
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="row mb-2">
                        <div className="form-label col-lg-4 col-md-4 col-12"># of Refills *</div>
                        <div className="col-lg-8 col-md-8 col-12">
                            <Controller
                                name="prescription_information_attributes.refills"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <div className="input-group input-group-custom small-input">
                                            <input
                                                {...field}
                                                type="text"
                                                onChange={(e) => field.onChange(e.target.value.replace(/[^0-9.]/g, ''))}
                                                className="form-control"
                                                style={{ borderColor: error ? '#dc3545' : '' }}
                                            />
                                            <span className="input-group-text">refills</span>
                                        </div>
                                        {error && <div className="text-danger text-small mt-2">{error.message}</div>}
                                    </>
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="row mb-2">
                        <div className="form-label col-lg-4 col-md-4 col-12"># of Boxes *</div>
                        <div className="col-lg-8 col-md-8 col-12">
                            <Controller
                                name="prescription_attributes.number_of_boxes"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <div className="input-group input-group-custom small-input">
                                            <input
                                                {...field}
                                                type="number"
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, '').slice(0, 2);
                                                    field.onChange(value);
                                                }}
                                                className="form-control"
                                                style={{ borderColor: error ? '#dc3545' : '' }}
                                            />
                                            <span className="input-group-text">boxes</span>
                                        </div>
                                        {error && <div className="text-danger text-small mt-2">{error.message}</div>}
                                    </>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AfrezzaPrescription;
